import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { ViewportService } from '../services/viewport.service';

/**
 * Blocks routes flagged `data: { desktopOnly: true }` from being reached on
 * any non-desktop viewport (mobile ≤767 and tablet 768–1174). Redirects to
 * `/desktop-only` (TASK-59145; widened from mobile-only after the FixMobile
 * audit found tablet was bypassing the guard by deep link).
 *
 * Belt-and-suspenders alongside the menu-drawer allowlist:
 *  - the drawer doesn't show the entry on mobile/tablet, but
 *  - deep links, bookmarks, browser back-button, and in-app `routerLink`
 *    bypass the drawer; this guard catches all of them.
 *
 * Routes without `data.desktopOnly` are allowed unconditionally — the guard
 * is a no-op for them.
 */
export const MobileBlockedGuard: CanActivateFn = (route): true | UrlTree => {
  if (route.data?.['desktopOnly'] !== true) return true;

  const viewport = inject(ViewportService);
  if (viewport.isDesktop()) return true;

  const router = inject(Router);
  return router.parseUrl('/desktop-only');
};
